// Language mappings for the application
export const LANGUAGES = {
  en: 'English',
  ar: 'Arabic',
  zh: 'Chinese',
  nl: 'Dutch',
  fr: 'French',
  de: 'German',
  it: 'Italian',
  pt: 'Portuguese',
  ru: 'Russian',
  es: 'Spanish'
};

// Array of language options for dropdowns
export const LANGUAGE_OPTIONS = Object.entries(LANGUAGES).map(([code, name]) => ({
  code,
  name
}));
